import BaseAPI from "@/apis/base/base-api";

class LoginHistoryAPI extends BaseAPI {
  constructor() {
    super();
  }

  // Sử dụng Management API endpoint từ config
  apiName = "Management";
  controllerName = "loginhistory";

  /**
   * Ghi lại lịch sử đăng nhập
   * Chỉ cần gọi POST không cần truyền data
   */
  async recordLoginHistory() {
    let request = {
      url: this.getAPIUrl(), // POST https://localhost:44358/loginhistory
    };
    return await this.postAsync(request, false, false);
  }
}

export default new LoginHistoryAPI();
